<template>
    <div class="card">
        <router-link :to="'/trailers/' + trailer.assetId" class="trailer-list">
            <smart-img preset="format-32-md" :src="trailerTypeImageUrl(trailer)" class="card-img-top" alt="" />
            <span v-if="isQuoted(trailer.assetId)" class="badge badge-light border font-weight-normal isQuoted"><i class="far fa-check green"></i> Added to Quote</span>
            <div class="card-body">
                <div class="card-title mb-1">
                    <small class="text-uppercase mb-0 small d-block grey mb-1">{{ trailer.details.manufacturer }}</small>
                    <span class="trailer-name">{{ trailer.details.name }}</span>
                </div>
                <div class="small text-uppercase">
                    <span class="badge badge-light grey font-weight-normal mr-1" v-for="(badge, i) in trailerGetBadges(trailer)" :key="i">{{ badge }}</span>
                    &nbsp;
                </div>
            </div>
        </router-link>
        <div class="card-footer py-3">
            <div class="card-text small">
                <span v-if="!availableFrom">
                  <i class="fal fa-calendar-exclamation mr-1"></i> Coming soon
                </span>
                <span v-else>
                  <i class="fal fa-calendar-check mr-1"></i> {{ availableFrom }}
                </span>
                <br>
                <i class="fal fa-map-marker-alt mr-1" style="margin-left:1px"></i> {{ location }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    props: ["trailer"],
    computed: {
        ...mapGetters('quote', ['isQuoted']),
        ...mapState('locations', ['locations']),
        availableFrom: function () {
            if (!this.trailer.availableFrom) {
                return null
            }

            return this.$moment(this.trailer.availableFrom).format('DD/MM-YYYY')
        },
        location: function () {
            if (!this.trailer.depotSlug || !this.locations[this.trailer.depotSlug]) return 'N/A'
            return this.locations[this.trailer.depotSlug].city + ', ' + this.locations[this.trailer.depotSlug].country
        }
    }
}
</script>